import { createBrowserHistory } from './history.js';

/**
 * Create a default instance for the current document.
 */
export default createBrowserHistory();
